<template>
  <router-view/>
</template>
<script>
export default {
  name: 'app',

  created() {
    this.$store.dispatch('getAccessToken')
      .then(() => {
        this.$store.dispatch('getAmbiences');
        this.$store.dispatch('getStores');

        let params = window.location.search;
        let urlParams = new URLSearchParams(params);
        this.$root.$i18n.locale = urlParams.get('locale') ?? 'nl';
      });
  }

};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
